// extracted by mini-css-extract-plugin
export default {"container":"TgZWKq","thumbnailRatioContainer":"awy_A5"};